import React from 'react';
import { Box } from '@mui/material';

const SectionLayout = ({ left, right }) => (
  <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, gap: 4, alignItems: 'center', py: 4 }}>
    <Box sx={{ flex: 1 }}>{left}</Box>
    <Box sx={{ flex: 1 }}>{right}</Box>
  </Box>
);

export default SectionLayout; 